import { AccountSignUpAction } from '@app/store/account/sign-up/actions';
import { ACCOUNT_SIGN_UP_USER_EMAIL_SET } from '@app/store/actionTypes';

type AccountSignUpSignUpEmailState = string | null;

const initialState: AccountSignUpSignUpEmailState = null;

export default function reducer(
  state: AccountSignUpSignUpEmailState = initialState,
  action: AccountSignUpAction
) {
  switch (action.type) {
    case ACCOUNT_SIGN_UP_USER_EMAIL_SET:
      return action.payload;
    default:
      return state;
  }
}
